module.exports = __webpack_public_path__ + "img/accident_disabled_100.01f12818.svg";